import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f15939e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "badge" }

import { computed, onMounted, onUnmounted } from 'vue'
import { IonFabButton, IonIcon } from '@ionic/vue'
import { mailOutline } from 'ionicons/icons'
import { useRouter } from 'vue-router'
import { useUnreadMessages } from '@/composables/useUnreadMessages'


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingMessageIndicator',
  setup(__props) {

const router = useRouter()
const { unreadCount, startPolling, stopPolling } = useUnreadMessages()

// Mostrar hasta 99, después "99+"
const displayCount = computed(() => {
  return unreadCount.value > 99 ? '99+' : unreadCount.value.toString()
})

const goToMessages = () => {
  router.push('/mensajes')
}

onMounted(() => {
  if (localStorage.getItem('token')) {
    startPolling(600000) // Polling cada 10 minutos
  }
})

onUnmounted(() => {
  stopPolling()
})

return (_ctx: any,_cache: any) => {
  return (_unref(unreadCount) > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "floating-message-indicator",
        onClick: goToMessages
      }, [
        _createVNode(_unref(IonFabButton), {
          color: "primary",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(mailOutline) }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, _toDisplayString(displayCount.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})